import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  baseUrl: string = environment.API_SERVER;
  constructor(private _http: HttpClient) {}

  getAppConfigs(payload) {
    return this._http.get(this.baseUrl + '/admin/app_configs/', {
      params: payload.params,
    });
  }
  getUsersAppConfigs(payload) {
    return this._http.get(
      this.baseUrl +
        `/users/${payload.appUserId}/app_config/${payload.appConfigId}`
    );
  }

  addAppConfig(payload) {
    return this._http.post(this.baseUrl + '/admin/app_configs/', payload.body);
  }

  updateAppConfig(payload) {
    return this._http.put(
      `${this.baseUrl}/admin/app_configs/${payload.appConfigId}/`,
      payload.body
    );
  }

  deleteAppConfigs(payload) {
    return this._http.delete(
      `${this.baseUrl}/admin/app_configs/${payload.appConfigId}/`
    );
  }
}
